/**
 * Utility function to map shipment status to the corresponding table key
 * used for storing column configurations in the user's preferences.
 * 
 * @param status - The shipment status from the router query (e.g., 'TO_FIX', 'READY', etc.)
 * @returns The table key string for storing/retrieving column configuration
 */
export const getTableKeyFromStatus = (status?: string): string => {
  if (!status) return 'shipmentsTable';
  
  const statusUpper = status.toUpperCase();
  if (statusUpper === 'TO_FIX') return 'shipmentsTableToFix';
  if (statusUpper === 'READY') return 'shipmentsTableReady';
  if (statusUpper === 'COMPLETE') return 'shipmentsTableComplete';
  if (statusUpper === 'CANCELLED') return 'shipmentsTableCancelled';
  
  return 'shipmentsTable'; // fallback
};
